// TelcoTrack - Construction Diary shared module
// Exportuje Diary modaly pro použití v AppModule (globální trigger) + lazy-loaded
// ConstructionDiaryModule (záložka /diary) + globální modal pro zápis deníku.

import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { DiaryEntryModalComponent } from './components/diary-entry-modal/diary-entry-modal.component';
import { DiarySignaturePadComponent } from './components/diary-signature-pad/diary-signature-pad.component';
import { DiaryWorkRoutePreviewComponent } from './components/diary-work-route-preview/diary-work-route-preview.component';

@NgModule({
  declarations: [
    DiaryEntryModalComponent,
    DiarySignaturePadComponent,
    DiaryWorkRoutePreviewComponent,
  ],
  imports: [SharedModule],
  exports: [
    DiaryEntryModalComponent,
    DiarySignaturePadComponent,
    DiaryWorkRoutePreviewComponent,
  ],
})
export class ConstructionDiarySharedModule {}
